import React, { Suspense } from "react";
import { connect, ConnectedProps } from "react-redux"
import { isEmpty } from 'lodash';
import { Outlet, useParams, useLocation } from "react-router-dom";
import { Dispatch } from "@reduxjs/toolkit";
// components
import ScrollToTop from '@/components/ScrollToTop';
// actions
import CoreAction from "@/core/actions/common/CoreAction";
import ContentMetricsServiceAction from "@/core/actions/services/metrics/ContentMetricsAction";
// interfaces
import TClientSiteSettingDetail from "../types/TClientSiteSettingDetail";
import TClientLanguage from "@/core/types/TClientLanguage";
// types
import EContentMetricsType from "@/core/enums/EContentMetricsType";
// lazy element
const Header = React.lazy(() => import("@/components/Header"));
const Footer = React.lazy(() => import("@/components/Footer"));


const mapStateToProps = ( state:any ) => {
    console.log("WebApplicationLayout.mapStateToProps: ", state);

    const webApplicationLanguage:TClientLanguage    = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string         = webApplicationLanguage?.code;
    const webApplicationLanguageISOCode:string      = state.CoreStore.languageCode?.payload;

    const siteSettingsPayload:TClientSiteSettingDetail|null        = state.SiteSettingStore.details.payload;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingsPayload
    }
}

const mapDispatchToProps = ( dispatch:Dispatch ) => {
    console.log("WebApplicationLayout.mapDispatchToProps");

    const coreAction = new CoreAction(dispatch);
    const contentMetricsServiceAction = new ContentMetricsServiceAction(dispatch, "");

    return {
        _viewEvent: ( contentId:string, webApplicationLanguageCode:string ) => {
            contentMetricsServiceAction.post({ 
                servicePayload: {
                    body: {contentId: contentId, metricType: EContentMetricsType.VIEW}, 
                    language: webApplicationLanguageCode 
                }
            });
        },
        _showLoader: () => { 
            coreAction.showLoader(); 
        },
        _hideLoader: () => { 
            coreAction.hideLoader(); 
        }
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>
type TWebApplicationLayout<T> = {

} & T;


const WebApplicationLayout = ( props:TWebApplicationLayout<PropsFromRedux> ) => {
    console.log("WebApplicationLayout.rendered: ", props);

    const location = useLocation();
    const { category, categoryId, content, contentName, contentId } = useParams();
    const { 
        webApplicationLanguageCode,webApplicationLanguageISOCode,siteSettingsPayload,
        _showLoader,_hideLoader,_viewEvent
    } = props;

    if ( !isEmpty(siteSettingsPayload) ) {
        return (
            <>
                <ScrollToTop />
                <div className="App">
                    <Suspense><Header /></Suspense>
                    <Outlet 
                        context={{
                            category,
                            categoryId,
        
                            content,
                            contentName,
                            contentId,

                            webApplicationLanguageCode,
                            webApplicationLanguageISOCode,
                            siteSettingPayload: siteSettingsPayload,
                            
                            location,
                            _showLoader,
                            _hideLoader,
                            _viewEvent: (_contenId:string) => { _viewEvent(_contenId, webApplicationLanguageCode) }
                        }}
                    />
                    <Suspense><Footer /></Suspense>
                </div>
            </>
        )
    }
    
    return null;
}

const Component = React.memo(WebApplicationLayout, ( prevProps:TWebApplicationLayout<PropsFromRedux>, nextProps:TWebApplicationLayout<PropsFromRedux> ) => {
    console.log("WebApplicationLayout.memo", { prevProps, nextProps });
    return !(
        prevProps.webApplicationLanguageCode !== nextProps.webApplicationLanguageCode
    )
});

export default connector(Component);
